import { useQuery } from '@apollo/client';
import { RouteComponentProps } from '@reach/router';
import MintRedeem from 'common/components/MintRedeem/MintRedeem';
import { QueryItemsResponse } from 'common/models/graphql';
import { Treasury } from 'common/models/treasury';
import { REFRESH_INTERVALS } from 'constants/constants';
import { listTreasuriesOnChainQuery } from 'graphql/queries/listTreasuries.query';
import useSelectedChain from 'hooks/useSelectedChain';
import React, { FC } from 'react';

const MintRedeemContainer: FC<RouteComponentProps> = () => {
  const { chainId } = useSelectedChain();

  const { loading, data } = useQuery<QueryItemsResponse<Treasury>>(
    listTreasuriesOnChainQuery(chainId),
    {
      fetchPolicy: 'cache-and-network',
      pollInterval: REFRESH_INTERVALS['listTreasuries'],
    }
  );

  const treasuries = data?.listTreasuries?.items || [];
  return <MintRedeem treasuries={treasuries} isLoadingTreasuries={loading} />;
};

export default MintRedeemContainer;
